import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({providedIn: 'root'})
export class LayoutService {
  http = inject(HttpClient);

  loadColors(): Promise<void> {
    return this.http
      .get<any>(
        `assets/instances-config/${environment.currentInstance}/layout/visual-identity/variables/variables.json`,
      )
      .toPromise()
      .then((data) => {
        const colors = data;
        if (colors) {
          this.applyColors(colors);
        } else {
          console.warn(`No colors defined for instance: ${environment.currentInstance}`);
        }
      });
  }

  private applyColors(colors: {[key: string]: string}) {
    const root = document.documentElement;
    // Aplicar as variáveis CSS no :root
    Object.keys(colors).forEach((key) => {
      root.style.setProperty(`--${key}`, colors[key]);
    });
  }
}
